import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  insertStockCheck (params) { // 盘点入库
    return axios.post(global.IMS_STOCK + 'Check/insertStockCheck', params)
  }
}
//  global.IMS_STOCK + 'Check/insertStockCheck'
// 'http://192.168.9.35:8005/msi/ims/stockCheck/insertStockCheck'



// WEBPACK FOOTER //
// ./src/request/ims/checkStock.js